import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const AccountDefaultIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M8 10.02c2.79 0 5.11 1.96 5.45 4.48H2.55c.35-2.52 2.66-4.48 5.45-4.48Zm0-1c-3.58 0-6.5 2.75-6.5 6.14v.34h13v-.34c0-3.38-2.92-6.14-6.5-6.14ZM8 1.5c1.71 0 3.11 1.39 3.11 3.09S9.72 7.68 8 7.68 4.89 6.29 4.89 4.59 6.28 1.5 8 1.5Zm0-1C5.74.5 3.89 2.34 3.89 4.59S5.73 8.68 8 8.68c2.27 0 4.11-1.84 4.11-4.09S10.26.5 8 .5Z" />
  </IconWrapper>
)

export default AccountDefaultIconSmall
